import React from "react";
import type { KgOntologyOrbitIconProps } from "./KgOntologyOrbitIcon.types";

/** Orbit icon for ontology nodes (panel header + used-in sections). */
export const KgOntologyOrbitIcon: React.FC<KgOntologyOrbitIconProps> = ({
  size = 14,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6663 4.66667C13.4027 4.66667 13.9997 4.06971 13.9997 3.33333C13.9997 2.59695 13.4027 2 12.6663 2C11.93 2 11.333 2.59695 11.333 3.33333C11.333 4.06971 11.93 4.66667 12.6663 4.66667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 14.0007C4.06971 14.0007 4.66667 13.4037 4.66667 12.6673C4.66667 11.9309 4.06971 11.334 3.33333 11.334C2.59695 11.334 2 11.9309 2 12.6673C2 13.4037 2.59695 14.0007 3.33333 14.0007Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.93359 14.5996C8.21543 14.8102 9.53088 14.6418 10.7183 14.1149C11.9057 13.5881 12.9133 12.7258 13.6173 11.6341C14.3213 10.5424 14.691 9.26875 14.681 7.96976C14.671 6.67077 14.2817 5.40301 13.5609 4.32227"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00021 1.40062C7.72361 1.20567 6.41787 1.3857 5.24165 1.91882C4.06543 2.45194 3.06937 3.31521 2.3745 4.40373C1.67963 5.49224 1.31587 6.75915 1.32742 8.05049C1.33896 9.34184 1.72532 10.602 2.43954 11.678"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgOntologyOrbitIcon;
